<template>
  <VisibilityBicycles :variant="VisibilityBicycleViewMode.ARCHIVED" />
</template>

<script lang="tsx" setup>
import VisibilityBicycles from '@pages/visibility/visibilityBicycle/VisibilityBicycles.vue';
import { VisibilityBicycleViewMode } from '@/entities/Entities';
</script>

<style lang="scss" scoped>
</style>
